import React, { useContext } from 'react'
import { ProductsContext } from '../../Global/ProductsContext'
import { CartContext } from '../../Global/CartContext'

export const MyProducts = () => {
   
   // product context
    const { products } = useContext(ProductsContext);
    
    // cart context
    const { dispatch } = useContext(CartContext);

    return (
        <>
            {products.length !== 0 && <h1 className="headcenter">Products</h1>}
            <div className='products-container'>
                {products.length === 0 && <div>slow internet...no products to display</div>}
                {products.map(product => (
                    <div className='product-card' key={product.ProductID}>
                        <div className='product-img'>
                            <img src={product.ProductImg} alt="not found" />
                        </div>
                        <div className='product-name'>
                            {product.ProductName}
                        </div>
                        <div className='product-price'>
                        GH₵ {product.ProductPrice}.00
                    </div>
                        {/* <button className='addcart-btn' onClick={() => dispatch({ type: 'ADD_TO_CART', id: product.ProductID, product })}>BOOK NOW</button> */}
                    </div>
                ))}
            </div>
        </>
    )
}
